export default "__VITE_ASSET__1aff7876__"